export const RTC_PROTOCOL_V1 = {
    version: 1,
    membershipStateType: 'org.matrix.msc3401.call.member',
    futureMembershipStateType: 'm.call.member',
    keysToDeviceType: 'io.element.call.encryption_keys',
    notificationEventType: 'org.matrix.msc4075.rtc.notification',
    declineEventType: 'org.matrix.msc4310.rtc.decline',
    slot: { application: 'm.call', id: 'ROOM' },
    slotId: 'm.call#ROOM',
    transportType: 'livekit',
    transportsPath: '/_matrix/client/unstable/org.matrix.msc4143/rtc/transports',
    tokenPath: '/_matrix/client/unstable/io.element.msc4195/rtc/livekit/get_token',
    turnServerPath: '/_matrix/client/v3/voip/turnServer',
    wellKnownPath: '/.well-known/matrix/client',
    wellKnownFociKey: 'org.matrix.msc4143.rtc_foci',
    identityScheme: 'legacy-device',
    signalTopic: 'phq.call.signal.v1',
    maxParticipants: 30,
    ringLifetimeMs: 30000,
};
export const MEMBERSHIP_POWER_LEVEL_EVENTS = {
    [RTC_PROTOCOL_V1.membershipStateType]: 0,
    [RTC_PROTOCOL_V1.futureMembershipStateType]: 0,
};
export const E2EE_KEY_PROVIDER_OPTIONS = {
    sharedKey: false,
    ratchetSalt: 'LKFrameEncryptionKey',
    ratchetWindowSize: 0,
    failureTolerance: -1,
    keyringSize: 256,
    keySize: 128,
};
export const E2EE_KEY_DERIVATION = 'HKDF';
export const MEMBERSHIP_TIMING = {
    delayedLeaveEventDelayMs: 22000,
    delayedLeaveEventRestartMs: 5000,
    delayedLeaveEventRestartLocalTimeoutMs: 3000,
    maximumNetworkErrorRetryCount: 30,
    keyRotationGracePeriodMs: 10000,
    useKeyDelay: 1000,
    rejoinLeaveTimeoutMs: 2000,
    recoveryDelayMs: 2000,
    maxRecoveries: 3,
    recoveryWindowMs: 300000,
};
export const CALL_TIMING = {
    unmappedGraceMs: 15000,
    unencryptedGraceMs: 2000,
    maxMediaRejoins: 3,
    mediaRejoinWindowMs: 300000,
    mediaRejoinRetryDelaysMs: [1000, 3000, 10000, 20000, 30000],
    mediaReconnectStallMs: 30000,
    mediaHealthIntervalMs: 30000,
};
export const RTC_SESSION_EVENTS = {
    membershipsChanged: 'memberships_changed',
    joinStateChanged: 'join_state_changed',
    encryptionKeyChanged: 'encryption_key_changed',
    membershipManagerError: 'membership_manager_error',
    didSendCallNotification: 'did_send_call_notification',
    probablyLeft: 'ProbablyLeft',
};
export const RTC_SESSION_MANAGER_EVENTS = {
    sessionStarted: 'session_started',
    sessionEnded: 'session_ended',
};
export const REACTION_ALLOWLIST = ['👍', '👏', '😂', '❤️', '🎉', '😮', '🤔', '👎'];
export const SIGNAL_LIMITS = {
    maxBytes: 256,
    throttleCount: 5,
    throttleWindowMs: 5000,
};
export const RING_API = {
    collectionPath: '/api/v1/group-call-rings',
    targetsPath: '/api/v1/group-call-rings/targets',
    activeInvitesPath: '/api/v1/group-call-rings/mine/active',
};
export const RING_TO_DEVICE_EVENT = 'org.phonehq.call.ring';
export const RING_CONFLICT_REASONS = {
    callFull: 'call_full',
    targetNotJoined: 'target_not_joined',
};
